import httpService from "..";

export const searchGroupsApi = async (groupId: string, search: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/group/search?search=${search}&groupId=${groupId}`,
    "get"
  );
};

export const getGroupsApi = async () => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/group`,
    "get"
  );
};

export const getGroupApi = async (id: any) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/group/${id}`,
    "get"
  );
};

export const getUserGroupsApi = async (userId: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/group/user/${userId}`,
    "get"
  );
};

export const getLinkedGroupsApi = async (
  id: string,
  groupLinkId: string,
  groupLevel: string
) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/group/${id}/groupLink/${groupLinkId}?groupLevel=${groupLevel}`,
    "get"
  );
};

export const checkGroupPolicyNumberApi = async (id: string, data: any) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/group/check-policy-number/${id}`,
    "post",
    data
  );
};


export const addGroupApi = async (
  data: {},
  userId: number,
  groupId?: number,
  groupLevel?: number
) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/group?groupId=${groupId}&userId=${userId}&groupLevel=${groupLevel}`,
    "post",
    data
  );
};

export const sendGroupSmsApi = async (id: string, data: {}) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/group/${id}/send-sms`,
    "post",
    data
  );
};

export const editGroupApi = async (id: string, data: any) => {
  // BUG-23 / P3-07: BE persists NewPolicyEmail, DocumentEmail, NonPaymentEmail, LapseEmail
  // (cuid template IDs; null/"" clears a slot). Pass through with other group fields.
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/group/${id}`,
    "patch",
    data
  );
};

export const removeGroupApi = async (id: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/group/${id}`,
    "delete"
  );
};

export const getGroupMembersWithBalancesApi = async (groupId: string, groupLevel?: number) => {
  const levelParam = groupLevel ? `?groupLevel=${groupLevel}` : '';
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/group/${groupId}/members/balances${levelParam}`,
    "get"
  );
};
